import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-38 — Loading state for the KPI strip. Geometry matches
 * `<DashboardKpiStrip>` exactly (same grid, same tile padding) so the
 * Retry round-trip doesn't trigger a layout shift (UX Spec §3 lock —
 * "skeleton geometry matches loaded geometry").
 */
export function DashboardKpiSkeleton() {
  return (
    <section
      aria-busy="true"
      aria-label="Loading key metrics"
      data-testid="dashboard-kpi-skeleton"
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4"
    >
      {Array.from({ length: 4 }).map((_, i) => (
        <Card key={i} className="rounded-xl border p-5">
          <CardContent className="flex flex-col gap-2 p-0">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-9 w-20" />
          </CardContent>
        </Card>
      ))}
    </section>
  )
}
